
import { Component, Vue, Prop } from 'vue-property-decorator';
import { BaseIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BaseIcon
  }
})
/**
 * @deprecated - use Nebraska button instead
 */
export default class Button extends Vue {
  private NebraskaColors = NebraskaColors;
  /** Click event handler */
  // tslint:disable-next-line:no-empty
  @Prop({ type: Function, default: () => {} })
  private onClick!: () => {};

  /**
   *  Button size. Possible values:
   *  `xs, sm, md, lg`
   */
  @Prop({ type: String, default: 'lg' })
  private size!: string;

  /** Custom class */
  @Prop({ type: String })
  private className!: string;

  /** Background color */
  @Prop({ type: String })
  private background!: string;

  /** Text color */
  @Prop({ type: String })
  private textColor!: string;

  /** The element to be rendered */
  @Prop({ type: String, default: 'button' })
  private as!: string;

  /** Specifies if the button should be rendered as disabled */
  @Prop({ type: Boolean, default: false })
  private isDisabled!: boolean;

  /** Specifies if the button should be rendered as a block */
  @Prop({ type: Boolean, default: false })
  private isBlock!: boolean;

  /** Specifies if the button should processing as a spin */
  @Prop({ type: Boolean, default: false })
  private isProcessing!: boolean;

  private created() {
    console.warn(
      'Using deprecated Button, please use a Nebraska button instead.'
    );
  }

  private isEnumColor(color: any) {
    return Object.values(NebraskaColors).includes(color);
  }

  get computedStyle() {
    const computedStyle: { 'background-color'?: string; color?: string } = {};
    if (
      this.isEnumColor(this.background) ||
      (this.background && this.background.charAt(0))
    ) {
      computedStyle['background-color'] = this.background;
    }
    if (this.isEnumColor(this.textColor)) {
      computedStyle.color = this.textColor;
    }

    if (this.isDisabled) {
      return {};
    }

    return computedStyle;
  }

  private get computedClassName() {
    const isCustomColor = !!this.background || !!this.textColor;

    return [
      'wrn-button',
      `wrn-button-${this.size}`,
      isCustomColor ? 'wrn-button-custom' : '',
      this.background &&
      !this.isEnumColor(this.background) &&
      this.background.charAt(0) !== '#'
        ? `wrn-button-${this.background}`
        : '',
      this.textColor && !this.isEnumColor(this.textColor)
        ? `wrn-color-${this.textColor}`
        : '',
      this.isBlock ? `wrn-button-block` : '',
      this.isDisabled ? `disabled` : '',
      this.className
    ];
  }
}
